const pl = {
    common: {
        history: "wersja historyczna"
    }
};
export default pl;



// WEBPACK FOOTER //
// ./src/i18n/langs/pl.js